import { useThemeSync } from '@sphere/shared/util'

export const ThemeInitializer = () => {
  useThemeSync()
  return null
}
